(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.directive('daytaskReaction', ['$compile', 'SharedAgendaService', function ($compile, SharedAgendaService) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/tasks/templates/daytask-reaction.template.html',
            link: link
        };

        // escape dots('.'), slashes ('/'), backslashes ('\') and brackets ( '(' and ')' ) and more for use in a regex
        function escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        }

        function link(scope, element, attrs) {
            // make phonenumbers in task reaction content callable
            if (scope.reaction.content) {

                var agendaId = attrs.agendaId ? attrs.agendaId : SharedAgendaService.data.currentAgenda.id;
                var agendaCaption = attrs.agendaCaption ? attrs.agendaCaption : SharedAgendaService.data.currentAgenda.owner.caption;

                // find matches of numbers by regex
                var phoneNumberRegex = /(\d[\s\.\\\/()]?){8,}\d/g;
                var cleanRegex = /[\s(),\.\\\/]+/g;

                var content = `<span>${scope.reaction.content}</span>`;
                var matches = scope.reaction.content.match(phoneNumberRegex);

                // for every match -> make new link with contact-info-actions directive
                if (matches && matches.length > 0) {
                    for (var phoneNumberMatch of matches) {
                        if(phoneNumberMatch[0]!== "0"){continue;}
                        var isDate = (phoneNumberMatch.match(/\//g) || []).length > 1;                   
                        if (isDate) {
                            continue;
                        }
                        
                        var cleanPhoneNumber = phoneNumberMatch.replace(cleanRegex, '');
                        var replaceRegex = new RegExp(escapeRegExp(phoneNumberMatch.trim()) + '(?!" contact-info-type=")(?!<\/a><\/span>)', 'g');
                        content = content.replace(replaceRegex, 
                            `<span class="callable-phonenumber"><a contact-info-actions 
                                 agenda-id="${agendaId}" 
                                 agenda-caption="${agendaCaption}" 
                                 contact-info="${cleanPhoneNumber}" contact-info-type="2"
                                 uib-tooltip="{{'call'|translate}}"                                
                                 tooltip-append-to-body="true" 
                                 user-id="0"><i class="fa fa-phone"></i>${phoneNumberMatch}</a></span>`
                            );                       
                    }                

                    // compile
                    element.find("#content").html($compile(content)(scope));
                }
                else {
                    element.find("#content").html('<span>' + scope.reaction.content + '</span>');
                }
            }
        }

        return directive;


    }]);

})();
